import Swiper, { Scrollbar } from "swiper";

export default () => ({
  swiper: null,
  isMobile: null,
  showFixedHeight: null,

  viewPromotion(heading) {
    Tracking.viewPromotion("Product Slider", heading);
  },

  selectPromotion(heading) {
    Tracking.selectPromotion("Product Slider", heading);
  },

  setIsMobile() {
    this.isMobile = window.innerWidth < 1024 ? true : false;
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    this.showFixedHeight = params.has("fixedHeight");
  },

  initNostoMigration() {
    if (window.Nosto && typeof Nosto.migrateToShopifyMarket === "function") {
      Nosto.migrateToShopifyMarket({
        productSectionElement: ".nosto-product-info",
        productUrlElement: ".nosto-product-url",
        productTitleElement: ".x-nosto-title",
        productHandleAttribute: "x-nosto-handle",
        priceElement: ".nosto-newprice.money",
        listPriceElement: ".nosto-oldprice.money",
      });
    }
  },
  observeDomChanges(callback) {
    if (!window.MutationObserver) return;

    const target = document.getElementById("search-initial-products");
    if (!target) {
      console.warn("❌ [NOSTO] #search-initial-products not found");
      return;
    }

    // Observer for child content changes (Nosto injecting product info)
    const contentObserver = new MutationObserver(() => {
      const productInfo = target.querySelector(".nosto-product-info");
      if (productInfo) {
        callback(); // Run migration only when product content appears
      }
    });

    contentObserver.observe(target, {
      childList: true,
      subtree: true,
    });

    // Observer for visibility via class/style changes
    const visibilityObserver = new MutationObserver(() => {
      const style = window.getComputedStyle(target);
      const isVisible =
        style.display !== "none" && style.visibility !== "hidden";
      if (isVisible) {
        callback(); // Run migration when it becomes visible
      }
    });

    visibilityObserver.observe(target, {
      attributes: true,
      attributeFilter: ["style", "class"],
    });
  },

  initSlider() {
    this.setIsMobile();
    this.swiper = new Swiper(this.$refs.slider, {
      cssMode: true,
      preloadImages: false,
      slidesPerView: "auto",
      spaceBetween: 8,
      slidesOffsetBefore: 8,
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      breakpoints: {
        1024: {
          spaceBetween: 12,
          slidesOffsetBefore: 12,
        },
      },
      modules: [Scrollbar],
      preventClicks: false,
      preventClicksPropagation: false,
    });

    // Call Nosto migration after slider and DOM are initialized
    this.initNostoMigration();
  },

  slideNext() {
    this.swiper.slideTo(this.swiper.activeIndex + 2);
  },
  slidePrev() {
    this.swiper.slideTo(this.swiper.activeIndex - 2);
  },

  setUrl(fullUrl) {
    // Normalize root to not have leading or trailing slashes for later concatenation
    const root = window?.Shopify?.routes?.root || "/";
    const cleanRoot = root.replace(/^\/|\/$/g, "");

    // Try to extract path starting from `/products/...`
    const match = fullUrl.match(/\/products\/.+$/);
    const productPath = match
      ? match[0]
      : (() => {
          // fallback: slice from 4th segment onward
          const parts = fullUrl.split("/");
          return "/" + parts.slice(3).join("/");
        })();

    return cleanRoot ? `/${cleanRoot}${productPath}` : productPath;
  },
});
